import { connect } from 'react-redux';

import services from 'services';
import { openWindow } from 'store/actions/windows';
import Warning from '../../events/Warning';
import Error from '../../events/Error';
import { RackCall } from './RackCall';
import { Content, Barrier, IconTitle, Id } from './Rack.styled';

const rackIcons = {
  single_rack: 'single_rack.png',
  double_rack: 'double_rack.png',
  payment_terminal: 'payment_terminal.png',
  cashbox: 'cashbox-icon.png',
  server: 'data-server.png',
  goose: 'goose.svg',
};

const Rack = (props) => {
  /**
   * get icon for rack type
   * @returns
   */
  const getIcon = () => {
    const icon = rackIcons[props.type];
    if (!icon) {
      throw new Error('Не найдена иконка соотвествующая типу стойки');
    }
    return <img src={`/images/${icon}`} alt="" />;
  };

  /**
   * get barriers
   * @returns
   */
  const getBarriers = () => {
    switch (props.barriersCount) {
      case 2:
        return [<Barrier key="br_1" />, <Barrier key="br_2" />];
      case 1:
        return <Barrier />;
      case 0:
        return null;
      default:
        throw new Error('Wrong number of barriers');
    }
  };

  const showWindow = () => {
    props.openWindow({
      id: props.id,
      type: 'rack',
      data: { id: props.id, type: props.type, barriersCount: props.barriersCount, withSignals: !!props.events.length },
      header: services.getNodeTitle(props.type, props.id, props.caption),
    });
  };

  const showEvent = () => {
    const events = [...props.events];
    events.sort((first, second) => {
      if (first.type === 'critical' && second.type === 'notification') {
        return -1;
      }
      if (first.type === 'notification' && second.type === 'critical') {
        return 1;
      }
      if ((first.type === 'critical' && second.type === 'info') || (first.type === 'notification' && second.type === 'info')) {
        return -1;
      }
      if ((first.type === 'info' && second.type === 'critical') || (first.type === 'info' && second.type === 'notification')) {
        return 1;
      }

      return 0;
    });

    const event = events[0];
    let Component = null;
    switch (event.type) {
      case 'critical':
        Component = Error;
        break;
      case 'notification':
        Component = Warning;
        break;
      default:
        return null;
    }
    return <Component key={'ev_' + event.id} data={event} showWindow={showWindow} />;
  };

  const getViewRackId = () => {
    //console.log(props)
    if (props.caption) {
      return props.caption;
    }
    return props.type === 'cashbox' ? '' : window.service.call('getEquipmentInnerId', props.id);
  };

  const cl = props.type;
  const cl0 = props.call ? 'with-call' : '';

  return (
    <Content>
      <Content onClick={() => showWindow()} className={cl0}>
        {props.barriersPosition === 'top' && getBarriers()}
        <IconTitle className={cl}>
          {getIcon()}
          <Id className={cl}>{getViewRackId()}</Id>
        </IconTitle>
        {props.barriersPosition === 'bottom' && getBarriers()}
      </Content>
      {props.events.length > 0 && showEvent()}
      {props.call && <RackCall info={props.call} />}
    </Content>
  );
};

const mapStateToProps = (store, props) => {
  const events = [];
  const rackEvents = store.events.events[props.id];
  for (let key in rackEvents) {
    let event = rackEvents[key];
    events.push(event);
  }

  const testCall = false;
  // console.log("store.calls.calls[props.id]", props.id, store.calls.calls);
  const call = testCall
    ? {
        status: 'wait',
        id: '1763459905.809795',
        source: '111',
        source_inner_id: 'goose-1',
      }
    : store.calls.calls !== undefined
      ? store.calls.calls[props.id]
      : null;
  return {
    events,
    call,
  };
};

export default connect(mapStateToProps, {
  openWindow,
})(Rack);
